<template>
  <el-card class="department card-main">
    <div class="content">
      <div class="left">
        <el-tree
        :data="departmentList"
        :props="props"
        node-key='deptId'
        default-expand-all
        @node-click='departmentClick'
        highlight-current
        ref="tree">
          <div class="custom-tree-node vessel_span" slot-scope="{ node, data }">
            <div class="nodeName">{{ data.deptName.length > 8 ? data.deptName.substring(0, 8) + '...' : data.deptName }}</div>
            <div class="icon" v-show="data.childNode || node.level === 1">
              <i class="el-icon-circle-plus" @click="departmentAdd(node,data)"
                v-if="node.level<3" v-show="$ButtonShow('SAAS_DEPT_ADD_01')"></i>
              <i class="el-icon-edit" @click="departmentUpdate(node,data)" v-show="$ButtonShow('SAAS_DEPT_EDT_01')"></i>
              <i class="el-icon-delete-solid" @click="departmentDelete(node, data)"
                v-if="!data.childNode && node.level!==1" v-show="$ButtonShow('SAAS_DEPT_DEL_01')"></i>
            </div>
          </div>
        </el-tree>
        <el-dialog :title="title" :visible.sync="dialogFormVisible" width='334px' class="dialog" :close-on-click-modal='false' destroy-on-close>
          <el-form ref="info" :model="info" label-width="80px" :rules="rules">
            <el-form-item label="组织名称" prop='deptName'>
              <el-input v-model="info.deptName" style='width: 200px;' maxlength='10' placeholder='请输入组织名称十个字'>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click='submitForm()' :disabled="submitShow">确认
              </el-button>
              <el-button @click='dialogFormVisible=false'>取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <div class="right">
        <p class="mb20">人员列表</p>
        <el-form ref="searchInfo" :model="searchInfo" :inline="true" class="global-form">
          <el-form-item prop="role">
            <el-select v-model="searchInfo.roleId" clearable placeholder="请选择角色">
              <el-option v-for="item in roleList" :label="item.roleName" :value="item.roleId" :key="item.roleId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="userName">
            <el-input v-model="searchInfo.userName" placeholder="请输入人员姓名" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary"
          icon="el-icon-plus"
          @click="onAdd"
          class="mb20"
          v-show="$ButtonShow('SAAS_USE_ADD_01')"
        >新增人员</el-button>
        <el-table class="global-table" stripe v-loading="tableData.loading" :data="tableData.data">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="item.minWidth||''"
            :show-overflow-tooltip = "item.showOverflowTooltip||false"
            v-for="(item,index) in tableData.tr"
            :key="index">
            <template slot-scope="scope">
              <template v-if="scope.column.property ==='isDel'">
                <span>{{scope.row.isDel===0?'启用':'禁用'}}</span>
              </template>
              <span v-else>{{scope.row[scope.column.property]}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260px" fixed="right">
            <template v-slot="{ row }">
              <template v-if="row.isAdmin!=='1'">
                <el-button type="text" @click="onDetail(row.userId)">查看</el-button>
                <el-button type="text" @click="onUpdate(row.userId)" v-show="$ButtonShow('SAAS_USE_EDT_01')">编辑</el-button>
                <el-button type="text" @click="onDisabled(row.userId)" v-show="$ButtonShow('SAAS_USE_EDT_05')">{{row.isDel===0?'禁用':'启用'}}</el-button>
                <el-button type="text" @click="onDelete(row.userId)" v-show="$ButtonShow('SAAS_USE_EDT_06')">删除</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <GlobalPagination
          @current-change="personnelGet"
          @size-change="personnelGet"
          :current-page.sync="page"
          :page-size.sync="size"
          :total="total">
        </GlobalPagination>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'departMent',
  data () {
    return {
      departmentList: [],
      roleList: [],
      props: {
        value: 'deptId',
        label: 'deptName',
        children: 'childNode'
      },
      dialogFormVisible: false,
      title: '新增组织',
      info: {
        deptId: '',
        deptName: '',
        parentDeptId: ''
      },
      rules: {
        deptName: [{ required: true, message: '请输入组织名称', trigger: ['blur'] }]
      },
      submitShow: false,
      searchInfo: {
        userName: '',
        roleId: '',
        deptId: ''
      },
      tableData: {
        loading: false,
        tr: [
          {
            label: '姓名',
            prop: 'userName',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '角色',
            prop: 'roleName',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '联系电话',
            prop: 'mobile',
            minWidth: '120',
            showOverflowTooltip: true
          },
          {
            label: '所属组织',
            prop: 'deptName',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '状态',
            prop: 'isDel',
            minWidth: '80',
            showOverflowTooltip: true
          }
        ],
        data: [{}]
      },
      total: 0,
      page: 1,
      size: 10
    }
  },
  created () {
    this.departmentListGet()
    this.roleListGet()
    this.personnelGet()
  },
  methods: {
    roleListGet () {
      this.$axios.get(this.$apis.system.getRoleList).then((res) => {
        this.roleList = res || []
      })
    },
    departmentListGet () {
      this.$axios.get(this.$apis.system.departmentList).then((res) => {
        this.departmentList = res || []
      })
    },
    // 部门点击
    departmentClick (data, node) {
      if ((data.childNode && data.childNode.length) || (!data.childNode && node.level === 1)) {
        node.isCurrent = false
      }
      this.searchInfo.deptId = node.level !== 1 ? data.deptId : ''
      this.onSearch()
    },
    // 新增组织
    departmentAdd (node) {
      this.title = '新增组织'
      this.dialogFormVisible = true
      this.info = {
        deptName: '',
        parentDeptId: node.data.deptId
      }
    },
    departmentUpdate (node, data) {
      this.title = '编辑组织'
      this.dialogFormVisible = true
      this.info = {
        deptId: data.deptId,
        deptName: data.deptName,
        parentDeptId: node.parent.data.deptId
      }
    },
    departmentDelete (node) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.system.departmentDelete, {
          deptId: node.data.deptId
        })
          .then(() => {
            this.$message.success('删除成功')
            this.departmentListGet()
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    submitForm () {
      this.$refs.info.validate((valid) => {
        if (valid) {
          this.submitShow = true
          const url = this.info.deptId
            ? this.$apis.system.departmentUpdate
            : this.$apis.system.departmentAdd
          this.$axios.post(url, this.info).then(() => {
            this.$message.success('保存成功')
            this.departmentListGet()
            this.submitShow = false
            this.dialogFormVisible = false
          })
            .catch(() => {
              this.submitShow = false
            })
        }
      })
    },
    // 人员列表数据请求
    personnelGet () {
      this.tableData.loading = true
      this.$axios.get(this.$apis.system.personnelPage, {
        ...this.searchInfo,
        page: this.page,
        size: this.size
      }).then((res) => {
        this.tableData.loading = false
        this.tableData.data = res.list || []
        this.total = res.total || 0
      })
        .catch(() => {
          this.tableData.loading = false
        })
    },
    onSearch () {
      this.page = 1
      this.personnelGet()
    },
    onAdd () {
      this.$router.push({ name: 'personnelAdd' })
    },
    onDetail (id) {
      this.$router.push({
        name: 'personnelDetail',
        params: {
          id: id
        }
      })
    },
    onUpdate (id) {
      this.$router.push({
        name: 'personnelUpdate',
        params: {
          id: id
        }
      })
    },
    onDisabled (id) {
      this.$axios.post(this.$apis.system.personnelDisabled, {
        userId: id
      }).then(() => {
        this.$message.success('操作成功')
        this.personnelGet()
      })
    },
    onDelete (id) {
      this.$confirm('是否确认删除该用户？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.system.personnelDelete, {
          userId: id
        }).then(() => {
          this.$message.success('操作成功')
          this.personnelGet()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
@import '@/assets/scss/variables.scss';
.department{
  ::v-deep .el-card__body {
    height: 100%;
    padding: 0px !important;
  }
  .content {
    height: 100%;
    display: flex;
    justify-content: space-between;
    .left{
      width: 300px;
      height: calc(100% - 40px);
      overflow-y: auto;
      background: #F6F8FB;
      padding: 12px;
      margin: 20px;
      box-shadow: 0px 1px 2px 0px rgba(139,172,237,0.1);
      border-radius: 10px;
      .el-tree {
        background: transparent;
      }
      .custom-tree-node {
        height: 36px;
        display: flex;
        align-items: center;
      }
      .is-current {
        >.el-tree-node__content {
          background-color: transparent;
          .nodeName {
            width: 140px;
            background: var(--color-primary);
            box-shadow: 0px 2px 4px 0px #E5E4FF;
            border-radius: 20px;
            font-size: 14px;
            font-weight: 400;
            line-height: 32px;
            color: #FFF;
            text-align: center;
          }
          .icon {
            display: block !important;
          }
        }
      }
      ::v-deep .el-tree-node__content{
        height: 32px;
        &:has(.expanded) {
          color: var(--color-primary);
        }
        .expanded {
          &:before {
            color: #000;
          }
        }
      }
      ::v-deep .el-tree-node__content{
        .icon{
          color:$--color-primary;
          display: inline-block;
        }
      }
      .nodeName{
        font-size: 14px;
      }
      .icon{
        position: absolute;
        right: 0;
        display: none;
        i{
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
    .right{
      width: calc(100% - 320px);
      height: 100%;
      padding: 20px;
      border-left: 1px solid #F4F4F4;
    }
  }
}
</style>
